import { useTranslation } from "react-i18next";
import { LanguageChooser } from "../LanguageChooser";
import { DropdownFilter } from "../../../../components/Filters/DropdownFilter";
import { useSearchContext } from "../../contexts";

interface LanguageChooserDropdownProps {
  onOpenChange?: (isOpen: boolean) => void;
}

export const LanguageChooserDropdown: React.FC<LanguageChooserDropdownProps> = ({ onOpenChange }) => {
  const { state } = useSearchContext();
  const { t } = useTranslation();
  return (
    <DropdownFilter
      title={t("Content languages")}
      counter={state.draftFilters.languages.value.length}
      isExclude ={state.draftFilters.languages.exclude}
      onOpenChange={onOpenChange}
    >
      <LanguageChooser />
    </DropdownFilter>
  )
};
